var _g;
import * as React from "react";
var SvgArrowLinkRight = function SvgArrowLinkRight(props) {
  return _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5, 6)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "10.62 0 14.02 3.4 10.62 6.79 8.23 6.79 10.63 4.39 0 4.39 0 2.4 10.62 2.4 8.23 0 10.62 0"
  })));
};
export default SvgArrowLinkRight;